import { render } from "./soluliveGrossMarginBarChart.vue?vue&type=template&id=3a824731"
import script from "./soluliveGrossMarginBarChart.vue?vue&type=script&lang=js"
export * from "./soluliveGrossMarginBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__